import React from "react";
import { Typography } from "antd";

const { Title, Paragraph } = Typography;

const CUSTOMER_STORIES = [
  {
    id: "agappe",
    company: "AGAPPE",
    logo: (
      <div className="customer-logo-wrapper agappe-logo-style">
        <span className="agappe-brand">AGAPPE</span>
      </div>
    ),
    quote: (
      <>
        DealVoice offers us technology that allows us to be{" "}
        <span className="quote-highlight">more proactive and insight-driven</span>, with all call
        information in a single place. With our complete business under control, our{" "}
        <span className="quote-highlight-accent">productivity is up by 80%</span> in the last year
        that we have been using DealVoice.
      </>
    ),
    author: "Thomas John",
    role: "Managing Director, Agappe",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=160&auto=format&fit=crop&q=80",
    fallbackAvatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=160&auto=format&fit=crop&q=80",
  },
  {
    id: "simplify9",
    company: "Simplify9",
    logo: (
      <div className="customer-logo-wrapper simplify9-logo-style">
        <svg
          className="simplify9-icon"
          viewBox="0 0 24 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 2L18 9L18 20L12 26L6 22L6 14L12 18L12 10L6 6L6 2Z"
            fill="#d9381e"
          />
        </svg>
        <span className="simplify9-text">Simplify9</span>
      </div>
    ),
    quote: (
      <>
        DealVoice for sales teams is{" "}
        <span className="quote-highlight">incredibly user-friendly and customizable</span>. Its
        intuitive interface makes it easy to navigate. The{" "}
        <span className="quote-highlight-accent">reporting telemetry was a standout</span>, providing
        clear insights that helped us make informed decisions.
      </>
    ),
    author: "Samer Zughul",
    role: "Managing Partner, Simplify9",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=160&auto=format&fit=crop&q=80",
  },
  {
    id: "minor-hotels",
    company: "MINOR HOTELS",
    logo: (
      <div className="customer-logo-wrapper minor-logo-style">
        <span className="minor-main">MINOR</span>
        <span className="minor-sub">HOTELS</span>
      </div>
    ),
    quote: (
      <>
        DealVoice helped us{" "}
        <span className="quote-highlight">automate our processes</span> after we implemented
        workflow rules. <span className="quote-highlight">Privacy and security</span> are essential for
        us, and DealVoice addressed it all. This was a{" "}
        <span className="quote-highlight-accent">game changer</span>.
      </>
    ),
    author: "Olga Kovshanova",
    role: "Director, Minor Hotels",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=160&auto=format&fit=crop&q=80",
  },
  {
    id: "aridhs7",
    company: "ARIDHS 7 CONSULTING",
    logo: (
      <div className="customer-logo-wrapper aridhs-logo-style">
        <div className="aridhs-icon-circle">
          <span className="aridhs-icon-inner">.\</span>
        </div>
        <div className="aridhs-text-wrap">
          <span className="aridhs-name">ARIDHS 7</span>
          <span className="aridhs-type">CONSULTING</span>
        </div>
      </div>
    ),
    quote: (
      <>
        I’m overall very satisfied with DealVoice. The{" "}
        <span className="quote-highlight">new telephony update</span> has{" "}
        <span className="quote-highlight-accent">significantly enhanced</span> the potential for
        effective team collaboration and faster deal closures.
      </>
    ),
    author: "Ari Daniel Hernandez Sanchez",
    role: "Marketing Director, Ava 7",
    avatar:
      "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=160&auto=format&fit=crop&q=80",
  },
];

function TestimonialsSection() {
  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonial-section-inner">
        <div className="testimonial-header-wrap">
          <span className="section-eyebrow-badge">VERIFIED CUSTOMER RESULTS</span>
          <Title level={2} className="testimonial-main-heading">
            How DealVoice automates deal closing,{" "}
            <span className="text-highlight-blue">in our customers’ words</span>
          </Title>
          <Paragraph className="section-main-subheading">
            Real growth, higher connect rates, and measurable revenue acceleration from fast-moving sales teams.
          </Paragraph>
        </div>

        <div className="testimonial-customer-grid">
          {CUSTOMER_STORIES.map((item) => (
            <div className="customer-story-card" key={item.id}>
              <div className="customer-card-top">
                {item.logo}
              </div>

              <div className="customer-card-quote">
                <Paragraph className="customer-quote-text">
                  {item.quote}
                </Paragraph>
              </div>

              <div className="customer-card-footer">
                <img
                  src={item.avatar}
                  alt={item.author}
                  className="customer-avatar-img"
                  loading="lazy"
                  onError={(e) => {
                    if (item.fallbackAvatar && e.target.src !== item.fallbackAvatar) {
                      e.target.src = item.fallbackAvatar;
                    }
                  }}
                />
                <div className="customer-profile-info">
                  <h4 className="customer-name">{item.author}</h4>
                  <p className="customer-role">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
